import Axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
Axios.defaults.baseURL = API_URL;

export class HttpService {
  _axios = Axios.create({
    baseURL: API_URL
  });


  addRequestInterceptor = (onFulfilled, onRejected) => {
    this._axios.interceptors.request.use(onFulfilled, onRejected);
  };

  addResponseInterceptor = (onFulfilled, onRejected) => {
    this._axios.interceptors.response.use(onFulfilled, onRejected);
  };

  get = async (url) => await this.request(this.getOptionsConfig("get", url));

  post = async (url, data) => await this.request(this.getOptionsConfig("post", url, data));

  put = async (url, data) => await this.request(this.getPatchPostOptionsConfig("put", url, data));

  patch = async (url, data) => await this.request(this.getPatchPostOptionsConfig("patch", url, data));

  delete = async (url) => await this.request(this.getOptionsConfig("delete", url));

  getOptionsConfig = (method, url, data) => {
    return {
      method,
      url,
      data,
      // Headers are set globally on the Axios instance; override here only if needed per-request
      headers: { "Content-Type": "application/json" },
    };
  };


  getPatchPostOptionsConfig = (method, url, data) => {
    return {
      method,
      url,
      data,
      // Headers are set globally on the Axios instance; override here only if needed per-request
      headers: { "Content-Type": "application/json" }
    };
  };

  request(options) {
    return new Promise((resolve, reject) => {
      this._axios
        .request(options)
        .then((res) => resolve(res.data))
        .catch((ex) => reject(ex.response.data));
    });
  }
}

export default new HttpService();
